export default __webpack_public_path__ + "static/IBMPlexSans-Text-Greek-9740e4234b892ffdb6b7d6b9e0b8f793.woff";